import { Module } from "wrapper6";
import 'core-js/fn/object/assign';
import 'core-js/fn/array/find';
import 'core-js/es6/promise';

import tippy from 'tippy.js';


var $ = jQuery;

export default class LexiconTooltip extends Module {

	ready(app) {

        const TOOLTIPS = document.querySelectorAll('.tooltip-wrapper');
        const TOOLTIP_TOGGLE = document.querySelector('#toggle-switch');
        
        if (TOOLTIPS) {
            for (let i = 0; i < TOOLTIPS.length; i++) {
                const TOOLTIP = TOOLTIPS[i];
                const CONTENT = TOOLTIP.querySelector('.tooltip-content');               
                
                const TIPPY = tippy(TOOLTIP, {
                    content: CONTENT,
                    placement: 'bottom',
                    arrow: true,
                    theme: 'word',
                    interactive: true,
                }); 

                TOOLTIP.addEventListener('mouseover', () => {
                    CONTENT.style.display = 'block';
                });               
                
                if (TOOLTIP_TOGGLE) {
                    TOOLTIP_TOGGLE.addEventListener('click', () => {
                        TOOLTIP.classList.toggle('hide-tippy');

                        if (TOOLTIP.classList.contains('hide-tippy')) {
                            TIPPY.disable();
                        } else {
                            TIPPY.enable();
                        }                
                    });
                }
            }           
        }
    }
}